import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useEstimatedCostPageStore } from 'store/pages/quote/estimated-cost/pageStore';
import { DynamicFormStyled, EstimatedCostFormWrapperStyled } from './styles';

const EstimatedCostForm: React.FC = observer(() => {
  const { dynamicJSONFormDelegate, fetchForm, isInitialLoading, returnBack } = useEstimatedCostPageStore();
  const formExists = dynamicJSONFormDelegate.formController;

  useEffect(() => {
    if (!isInitialLoading && !formExists) {
      void fetchForm();
    }
  }, [isInitialLoading, formExists]);

  return (
    <EstimatedCostFormWrapperStyled>
      <DynamicFormStyled
        formDelegate={dynamicJSONFormDelegate}
        completeButtonText="Save"
        backButtonText="Exit"
        onBack={returnBack}
      />
    </EstimatedCostFormWrapperStyled>
  );
});

export default EstimatedCostForm;
